var InitialStateSingleton = /** @class */ (function () {
    function InitialStateSingleton() {
        this.inViewFormInitialState = '';
    }
    InitialStateSingleton.getInstance = function () {
        if (!InitialStateSingleton.instance) {
            InitialStateSingleton.instance = new InitialStateSingleton();
        }
        return InitialStateSingleton.instance;
    };
    InitialStateSingleton.prototype.getInViewFormInitialState = function () {
        return this.inViewFormInitialState;
    };
    InitialStateSingleton.prototype.setInitialState = function (initialState) {
        this.inViewFormInitialState = initialState;
    };
    return InitialStateSingleton;
}());
export default InitialStateSingleton.getInstance();
//# sourceMappingURL=InitialState.js.map